<template>
  <li
    :class="['item', { 'has-responsive-rules': hasResponsiveRules }]"
    data-wptv="carousel-item"
    tabindex="-1">
    <div
      :class="[{selected: selected }, 'item-content']"
      @click="onClickEvent"
      @mouseenter="onMouseenter"
      @mouseleave="onMouseleave">
      <slot />
    </div>
  </li>
</template>

<script>

export default {
  name: 'WptvCarouselItem',
  props: {
    hasResponsiveRules: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    /**
     * click event on the element
     */
    onClickEvent () {
      this.$emit('item-click')
    },
    /**
     * mouseenter event on the element
     */
    onMouseenter () {
      this.$emit('item-mouseenter')
    },
    /**
     * mouseleave event on the element
     */
    onMouseleave () {
      this.$emit('item-mouseleave')
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../../scss/abstracts/variables';
@import '../../../scss/abstracts/mixins';

//============================ MEDIA QUERIES

//-- BEGIN Parent dependant

/* Generate responsive class for the carousel items (same logic as Foundation Grid)
.xxsmall-1, .xxsmall-2 ... .xxsmall-7
.xsmal-1, .xsmal-2 ... xsmal-7
...
*/

@each $bp_name, $value in $breakpoints {
  @for $i from 1 through 12 {
    @media screen and (min-width: #{$value}) {
      .#{$bp_name}-#{$i}_33 {
        $val: calc(#{$i} + 1/10);

        .item.has-responsive-rules {
          width: calc(100% / #{$val});
        }
      }
    }
  }
}

.carousel-container.dark {
  .item-content {
    color: $white;
  }
}

//-- END Parent dependant

.item:last-child {
  @include mediaQueries('margin-right', $main-padding-left);
}

//============================ STATICS CSS
.item {
  display: inline-block;
  vertical-align: top;
  user-select: none;
  outline-color: transparent;
  padding: 0 5px;
  box-sizing: border-box;

  > .item-content {
    cursor: pointer;
    height: 100%;
    width: 100%;
    border: 0;
    background: none;
    padding: 0;
    font-size: 1rem;

    &:focus {
      outline: transparent;
    }

    &:focus-within {
      outline: solid
    }
  }

  > * {
    // To disable the bump effect on button click on IE
    // http://stackoverflow.com/questions/6744406/internet-explorer-buttonactive-inner-padding
    position: relative;
  }
}

</style>
